export const RESPONSIVE_BRAND_BAR_HEIGHTS = {
  xs: '65px',
  lg: '84px',
};

export const BAR_HEIGHT = '56px';

export const JACKPOT_BAR_HEIGHT = '50px';
